import type { ReactElement } from 'react';

export interface GeneratePlanButtonProps {
  generating: boolean;
  consentFresh: boolean;
  freeExhausted: boolean;
  isPro: boolean;
  generationsThisMonth: number;
  freeTierLimit?: number;
  onGenerate: () => void;
  onNavigateUpgrade: () => void;
}

export function GeneratePlanButton({
  generating,
  consentFresh,
  freeExhausted,
  isPro,
  generationsThisMonth,
  freeTierLimit = 10,
  onGenerate,
  onNavigateUpgrade,
}: GeneratePlanButtonProps): ReactElement {
  return (
    <div className="generate-counter" data-testid="generate-counter">
      <button
        type="button"
        className="snap-button"
        data-state={
          freeExhausted ? 'locked' : consentFresh ? 'ready' : 'consent'
        }
        disabled={generating || !consentFresh}
        onClick={() => {
          if (freeExhausted) {
            onNavigateUpgrade();
            return;
          }
          onGenerate();
        }}
      >
        {generating
          ? 'Generating…'
          : freeExhausted
            ? '🔒 Upgrade to generate'
            : consentFresh
              ? 'Generate Plan'
              : 'Enable AI features in onboarding first'}
      </button>
      {!isPro && !freeExhausted && (
        <span className="tagline" data-testid="generate-counter-label">
          {generationsThisMonth} of {freeTierLimit} free generations used this
          month
        </span>
      )}
    </div>
  );
}
